export enum ChecklistCardEnum {
  Default = "default",
  Gold = "gold",
}
